import React from 'react'
import { Button } from 'react-bootstrap';
import { FaCarRear } from 'react-icons/fa6';
import { MdDateRange, MdHome, MdLocationOn, MdTimer } from 'react-icons/md';

const SectionSearchResultLocationAndDate = () => {
    return (
        <div className="container-fluid" style={{ padding: "150px 10px 30px 10px" }}>

            <div className="container">
                <div className="container-barner-home-section-horaire-card">
                    <div className="container-barner-home-section-horaire-card-button-patrimoine-active"><FaCarRear size={15} /> <span > Recherchez un véhicule</span> </div>
                    <div className="container-barner-home-section-horaire-card-button-patrimoine"><MdHome size={15} /> <span > Recherchez un véhicule</span> </div>
                </div>
                <div className="container-barner-home-section-horaire-card-2 shadow-sm">
                    <div className="row">
                        <div className="col-md-3">
                            <div style={{ color: "#737373" }}>Localisation</div>
                            <div style={{ color: "#D9D9D9" }}><MdLocationOn /><span> Algerie</span></div>
                        </div>
                        <div className="col-md-4">
                            <div style={{ color: "#737373" }}>Dates</div>
                            <div style={{ color: "#D9D9D9" }}><MdDateRange /><span> DD-MM-YYYY - DD-MM-YYYY</span></div>
                        </div>
                        <div className="col-md-3">
                            <div style={{ color: "#737373" }}>Horaire</div>
                            <div style={{ color: "#D9D9D9" }}><MdTimer /><span> 10:00 à 10:00</span></div>
                        </div>
                        <div className="col-md-2">
                            <Button variant="primary" style={{ borderRadius: "50px", padding: "10px 15px 10px 15px" }}>Rechercher</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SectionSearchResultLocationAndDate;
